var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "black",
    strokeOpacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70898 12H7.28516V5.66016H8.70898V12ZM7.19727 4.01367C7.19727 3.79492 7.26562 3.61328 7.40234 3.46875C7.54297 3.32422 7.74219 3.25195 8 3.25195C8.25781 3.25195 8.45703 3.32422 8.59766 3.46875C8.73828 3.61328 8.80859 3.79492 8.80859 4.01367C8.80859 4.22852 8.73828 4.4082 8.59766 4.55273C8.45703 4.69336 8.25781 4.76367 8 4.76367C7.74219 4.76367 7.54297 4.69336 7.40234 4.55273C7.26562 4.4082 7.19727 4.22852 7.19727 4.01367Z",
    fill: "black",
    fillOpacity: 0.55
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8ddfb098.svg";
export { ForwardRef as ReactComponent };